/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 反馈记录列表 的 **请求配置**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/getList`
 */
const postGetListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyPackageCheckRecord/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 反馈记录列表 的 **请求函数**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/getList`
 */
export const postGetList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetListRequestConfig, requestData), ...args);
};
postGetList.requestConfig = postGetListRequestConfig;
/**
 * 接口 详情 的 **请求配置**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/detail`
 */
const postDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyPackageCheckRecord/detail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 详情 的 **请求函数**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/detail`
 */
export const postDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postDetailRequestConfig, requestData), ...args);
};
postDetail.requestConfig = postDetailRequestConfig;
/**
 * 接口 详情 - 包裹列表 的 **请求配置**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/detailPackageList`
 */
const postDetailPackageListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyPackageCheckRecord/detailPackageList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDetailPackageList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 详情 - 包裹列表 的 **请求函数**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/detailPackageList`
 */
export const postDetailPackageList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postDetailPackageListRequestConfig, requestData),
    ...args
  );
};
postDetailPackageList.requestConfig = postDetailPackageListRequestConfig;
/**
 * 接口 详情 - 包裹列表 - 导出打标日志 的 **请求配置**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/exporPackagetDaBiaoRecord`
 */
const postExporPackagetDaBiaoRecordRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyPackageCheckRecord/exporPackagetDaBiaoRecord",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExporPackagetDaBiaoRecord",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 详情 - 包裹列表 - 导出打标日志 的 **请求函数**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/exporPackagetDaBiaoRecord`
 */
export const postExporPackagetDaBiaoRecord = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExporPackagetDaBiaoRecordRequestConfig, requestData),
    ...args
  );
};
postExporPackagetDaBiaoRecord.requestConfig =
  postExporPackagetDaBiaoRecordRequestConfig;
/**
 * 接口 详情 - 差异商品列表 的 **请求配置**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/detailPackageSkuList`
 */
const postDetailPackageSkuListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyPackageCheckRecord/detailPackageSkuList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDetailPackageSkuList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 详情 - 差异商品列表 的 **请求函数**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/detailPackageSkuList`
 */
export const postDetailPackageSkuList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postDetailPackageSkuListRequestConfig, requestData),
    ...args
  );
};
postDetailPackageSkuList.requestConfig = postDetailPackageSkuListRequestConfig;
/**
 * 接口 详情 - 一手入库包裹商品列表 - 导出打标日志 的 **请求配置**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/exporDetailPackageSkuListDaBiaoRecord`
 */
const postExporDetailPackageSkuListDaBiaoRecordRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyPackageCheckRecord/exporDetailPackageSkuListDaBiaoRecord",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExporDetailPackageSkuListDaBiaoRecord",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 详情 - 一手入库包裹商品列表 - 导出打标日志 的 **请求函数**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/exporDetailPackageSkuListDaBiaoRecord`
 */
export const postExporDetailPackageSkuListDaBiaoRecord = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(
      postExporDetailPackageSkuListDaBiaoRecordRequestConfig,
      requestData
    ),
    ...args
  );
};
postExporDetailPackageSkuListDaBiaoRecord.requestConfig =
  postExporDetailPackageSkuListDaBiaoRecordRequestConfig;
/**
 * 接口 详情 - 缺漏商品列表 的 **请求配置**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/supplyFeedbackGapdGoodsList`
 */
const postSupplyFeedbackGapdGoodsListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyPackageCheckRecord/supplyFeedbackGapdGoodsList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSupplyFeedbackGapdGoodsList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 详情 - 缺漏商品列表 的 **请求函数**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/supplyFeedbackGapdGoodsList`
 */
export const postSupplyFeedbackGapdGoodsList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSupplyFeedbackGapdGoodsListRequestConfig, requestData),
    ...args
  );
};
postSupplyFeedbackGapdGoodsList.requestConfig =
  postSupplyFeedbackGapdGoodsListRequestConfig;
/**
 * 接口 详情 - 仓库核实 的 **请求配置**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/verificationProcessing`
 */
const postVerificationProcessingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyPackageCheckRecord/verificationProcessing",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postVerificationProcessing",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 详情 - 仓库核实 的 **请求函数**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/verificationProcessing`
 */
export const postVerificationProcessing = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postVerificationProcessingRequestConfig, requestData),
    ...args
  );
};
postVerificationProcessing.requestConfig =
  postVerificationProcessingRequestConfig;
/**
 * 接口 详情 - 申诉处理 的 **请求配置**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/complaintHanding`
 */
const postComplaintHandingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyPackageCheckRecord/complaintHanding",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postComplaintHanding",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 详情 - 申诉处理 的 **请求函数**
 *
 * @分类 仓储API/入库差异反馈
 * @请求头 `POST /erp/SupplyPackageCheckRecord/complaintHanding`
 */
export const postComplaintHanding = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postComplaintHandingRequestConfig, requestData),
    ...args
  );
};
postComplaintHanding.requestConfig = postComplaintHandingRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/supplyPackageCheckRecord.js